import { ActionYd } from "./ActionYd.js";
import { Annotation } from "./Annotation.js";

export class AnnotationYd extends Annotation {
    constructor(args = {}) {
        super(args)

        this._data = args.data || null
        this._title_h = args.hoverTitle || ''
        this._isNormal = args.isNormal || false
        this.opacity = 1
        this.isAlreadyClicked = false
        this._icon = args.icon
        this._iconActive = args.iconActive
        // let iconClose = exports.resourcePath + '/icons/annotation_bg.png'
        this.extraParams = args.extraParams

        // 走基类 _setDomElement 而非直接赋值：替换后需按 _display 同步新元素的显隐，
        // 否则构造末尾 super 里的 display=false 只隐藏了被丢弃的基类元素（详见该方法注释）
        this._setDomElement($(`
                  <div class="yd-annotation-sxt" oncontextmenu="return false;">
                    <div class="yd-sxt-img"></div>
                    <div class="yd-sxt-img-pointImg">
                      <div class="yd-sxt-img-pointName"></div>
                    </div>
                  </div>
              `))

        // <div class="yd-sxt-img-2" style="position:absolute;bottom:-10px;color:#fff">${this.extraParams.productId}</div>

        this.imgdom = document.createElement('img')
        this.imgdom.src = this._icon
        this.imgdom.style.width = args.imgWidth || '58px'
        this.imgdom.style.height = args.imgHeight || '58px'
        this.ydsxtimg = this.domElement.find('.yd-sxt-img')
        this.ydsxtimg.append(this.imgdom)

        this.pointImg = document.createElement('img')
        //   this.pointImg.src = 'http://192.168.1.212:8080/ydrobot/2024/07/11/1720691683637.png'
        //   this.pointImg.style.width = '120px'
        // this.imgdom.style.height = args.imgHeight || '58px'
        this.ydsxtPointimg = this.domElement.find('.yd-sxt-img-pointImg')
        this.ydsxtPointimg.append(this.pointImg)

        this.ydsxtPointName = this.domElement.find('.yd-sxt-img-pointName')

        //   this.elTitlebar = this.domElement.find('.yd-annotation-titlebar')
        //   this.elTitlebar.append(this._title)
        //   this.elDescription = this.domElement.find('.yd-annotation-description')

        //   this.clickdom = this.domElement.find('.yd-des-bg-icon-middle')
        //   this.clickdom[0].innerHTML = args.click_dom || ''

        //   if (this._isNormal == true) {
        //     this.elTitlebar.css('cursor', 'auto')
        //     this.elDescription.css('position', 'relative')
        //     this.elDescription.css('display', 'block')
        //   } else {
        this.actions = this.actions.map((a) => {
            if (a instanceof ActionYd) {
                return a
            } else {
                return new ActionYd(a)
            }
        })

        for (let action of this.actions) {
            // this.elTitlebar.click(() => action.onclick({ annotation: this }))
            this.ydsxtimg.click(() => action.onclick(this))
        }

        this.domElement.mouseenter((e) => this.setHighlighted(true))
        this.domElement.mouseleave((e) => this.setHighlighted(false))

        this.domElement.on('touchstart', (e) => {
            this.setHighlighted(!this.isHighlighted)
        })
        //   }
    }

    setOpacity(opacity = 1) {
        if (this.ydsxtimg) {
            this.opacity = opacity
            this.ydsxtimg[0].style.opacity = opacity
        }
    }
    setPointImg({ name, path }) {
        console.log(name, path, '0-0-0-0-0-0')
        if (this.ydsxtPointimg) {
            this.pointImg.src = path
            this.ydsxtPointName[0].innerHTML = name
        }
    }

    showPointImg(params) {
        if (this.ydsxtPointimg) {
            this.ydsxtPointimg[0].style.display = params ? 'block' : ''
        }
    }

    setHighlighted(highlighted) {
        //   if (this._isNormal == true) return
        if (highlighted) {
            if (this.imgdom) {
                this.imgdom.src = this._iconActive
            }

            // this.elTitlebar.empty()
            // this.elTitlebar.append(this._title_h)
            // this.elDescription.fadeIn(200)
            // this.elDescription.css('position', 'relative')
        } else {
            if (this.imgdom) {
                this.imgdom.src = this._icon
            }
            // this.elTitlebar.empty()
            // this.elTitlebar.append(this._title)
            // this.elDescription.css('display', 'none')
        }

        this.isHighlighted = highlighted
    }

    dispose() {
        // 解绑点击事件，置空 img 引用，帮助 GC
        if (this.ydsxtimg) {
            this.ydsxtimg.off()
        }
        this.imgdom = null
        this.pointImg = null
        this.ydsxtimg = null
        this.ydsxtPointimg = null
        this.ydsxtPointName = null

        super.dispose()
    }
}